var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.$t('sarala-table.labels.search'),"clearable":"","append-icon":"mdi-magnify"},on:{"input":function($event){_vm.val = $event !== null ? $event : undefined}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }